import { ArrowRight, ClipboardCheck } from "lucide-react";
import EnLineaPagos from "../Enlineapagos";
import DescuentosEnlinea from "../../newPages/homenew/DescuentosEnlinea";
import Accordion from "../Accordion";

export default function RequisitosSection(props) {
  return (
    <section id="proceso" className="bg-slate-50 py-10">
      <div className="max-w-6xl m-auto px-6">
        {props.requisitosenlinea && (
          <>
            <div className="py-10">
              <div
                className=" 
            [&_h2]:font-bold
                [&_h3]:text-[#febe10]
                [&_h3]:text-lg
                [&_h3_strong]:text-lg
                 [&_h3]:m-0
                  [&_h3]:p-0"
                dangerouslySetInnerHTML={{
                  __html: props.requisitosenlinea,
                }}
              />{" "}
              {props.publicadoenlinea && (
                <div>
                  {props.enlaceenlinea && (
                    <>
                      <div className=" flex mt-8">
                        <a
                          href={props.enlaceenlinea}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-amber-400 hover:bg-blue-700 hover:text-white text-[#004270] px-8 py-4 rounded-2xl font-semibold transition-all flex items-center gap-2 shadow-2xl"
                        >
                          Matricúlate ahora
                          <ArrowRight size={18} />
                        </a>
                      </div>{" "}
                    </>
                  )}

                  <div className="mt-10">
                    <Accordion
                      title="Conoce nuestros descuentos y becas"
                      content={
                        <>
                          <DescuentosEnlinea></DescuentosEnlinea>
                        </>
                      }
                    ></Accordion>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/*REQUISITOS PRESENCIAL */}
        {props.requisitospresencial && (
          <>
            <div className="py-10">
              <div
                className=" 
                [&_h2]:font-bold
                [&_h3]:text-[#febe10]
                [&_h3]:text-lg
                [&_h3_strong]:text-lg
                      [&_h3]:m-0
                  [&_h3]:p-0"
                dangerouslySetInnerHTML={{
                  __html: props.requisitospresencial,
                }}
              />{" "}
              {props.publicadopresencial && (
                <div className=" flex mt-8">
                  <a
                    href={props.enlacepresencial}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-amber-400 hover:bg-blue-700 hover:text-white text-[#004270] px-8 py-4 rounded-2xl font-semibold transition-all flex items-center gap-2 shadow-2xl"
                  >
                    Inscríbete ahora
                    <ArrowRight size={18} />
                  </a>
                </div>
              )}{" "}
            </div>
          </>
        )}
      </div>{" "}
    </section>
  );
}
